document.addEventListener("DOMContentLoaded", () => {
  $(".product-single__description iframe").wrap(
    `<div class="video-wrapper"></div>`
  );

  $(".product-variant-list").each(function () {
    if ($(this).text().trim() === "") {
      $(this).remove();
    }
  });


  /** 文案浮动动画*/
  if ($(window).width() > 1000) {
    $(window).scroll(function () {
      $(".product-single__description>.grid").each(function () {
        if (
          $(window).scrollTop() + ($(window).height() * 2) / 3 >
          $(this).offset().top
        ) {
          $(this).find(".text-box").addClass("normalmove");
        } else {
          $(this).find(".text-box").removeClass("normalmove");
        }
      });

      $(".text_and_image").each(function () {
        if (
          $(window).scrollTop() + ($(window).height() * 2) / 3 >
          $(this).offset().top
        ) {
          $(this).find(".text_box").addClass("normalmove");
        } else {
          $(this).find(".text_box").removeClass("normalmove");
        }
      });
    });
  }

  // 产品对比表格
  (function () {
    $(".audio_des").wrap(`<div class="audio_des_wrapper"></div>`);
    // 为 audio-boxcontainer-copy 表格添加左右翻动按钮
    const $wrapper = $(".product-tab-content-container .audio_des_wrapper");
    if (!$wrapper.has(".audio-boxcontainer-copy").length) return;

    const container = document.querySelector(".audio_des");
    const $container = $(container);
    const $prevElement = $(
      `<div class="table-button-prev swiper-button-prev-home"><svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 42C33.046 42 42 33.046 42 22C42 10.954 33.046 2 22 2C10.954 2 2 10.954 2 22C2 33.046 10.954 42 22 42Z" stroke="currentColor" stroke-width="3" stroke-linejoin="round"></path><path d="M25 31L16 22L25 13" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg></div>`
    );
    const $nextElement = $(
      `<div class="table-button-next swiper-button-next-home"><svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 42C33.046 42 42 33.046 42 22C42 10.954 33.046 2 22 2C10.954 2 2 10.954 2 22C2 33.046 10.954 42 22 42Z" stroke="currentColor" stroke-width="3" stroke-linejoin="round"></path><path d="M19 31L28 22L19 13" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg>`
    );
    if (!$container.has(".table-button-prev").length) {
      $prevElement.on("click", () => {
        const left = $container.scrollLeft();
        container.scrollTo({
          left: left - 200,
          behavior: "smooth",
        });
      });
      $nextElement.on("click", () => {
        const left = $container.scrollLeft();
        container.scrollTo({
          left: left + 200,
          behavior: "smooth",
        });
      });
      $wrapper.append($prevElement);
      $wrapper.append($nextElement);
      function reloadButton() {
        const $swipeHeading = $(container.querySelector(".heading--swipe"));
        if (container.clientWidth == container.scrollWidth) {
          $prevElement.hide();
          $nextElement.hide();
          $swipeHeading.hide();
        } else {
          $prevElement.show();
          $nextElement.show();
          $swipeHeading.show();
        }
        if (container.scrollLeft == 0) {
          $prevElement.addClass("disabled");
          $nextElement.removeClass("disabled");
        } else if (
          container.scrollLeft + container.clientWidth >=
          container.scrollWidth
        ) {
          $prevElement.removeClass("disabled");
          $nextElement.addClass("disabled");
        } else {
          $prevElement.removeClass("disabled");
          $nextElement.removeClass("disabled");
        }
      }
      reloadButton();
      window.addEventListener("load", () => reloadButton());
      container.addEventListener("scroll", reloadButton);
      window.addEventListener("resize", reloadButton);
    }
    if ($container.has(".swiper-wrapper").length) {
      $wrapper.addClass("has--swiper"); // 俩表格打架，迫不得已
    }
  })();

  // 带有 Swiper 的另一种 ".audio-boxcontainer-copy" 表格
  (function () {
    const table = document.querySelector(".keyboard-comparison-table");
    if (table) {
      new Swiper(table, {
        slidesPerView: "auto",
        spaceBetween: 0,
        allowTouchMove: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1600: {
            slidesPerView: 5,
          },
          1400: {
            slidesPerView: 4,
            spaceBetween: 0,
          },
          1000: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
          590: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        },
      });
    }
  })();

  // 音频播放功能
  (function () {
    function showSound(audioSrc) {
      $(".hint").remove();
      var audioJQ = $("<audio src='" + audioSrc + "' autoplay class='hint'/>");
      audioJQ.appendTo(".audio_des");
    }
    $("#hintButton").click(function () {
      showSound(
        "https://cdn.shopify.com/s/files/1/0012/4957/4961/files/k586-01.mp3?v=1584587866"
      );
      $(this).find(".soundwave-active").addClass("playing");
      setTimeout(function () {
        $("#hintButton").find(".soundwave-active").removeClass("playing");
      }, 400);
    });
    $("#hintButton02").click(function () {
      showSound(
        "https://cdn.shopify.com/s/files/1/0012/4957/4961/files/k586-02.mp3?v=1584587872"
      );
      $(this).find(".soundwave-active").addClass("playing");
      setTimeout(function () {
        $("#hintButton02").find(".soundwave-active").removeClass("playing");
      }, 400);
    });
    $("#hintButton03").click(function () {
      showSound(
        "https://cdn.shopify.cn/s/files/1/0012/4957/4961/files/guangzhouchazhou.mp3?v=1588140129"
      );
      $(this).find(".soundwave-active").addClass("playing");
      setTimeout(function () {
        $("#hintButton03").find(".soundwave-active").removeClass("playing");
      }, 400);
    });
    $("#hintButton04").click(function () {
      showSound(
        "https://cdn.shopify.cn/s/files/1/0012/4957/4961/files/putongchazhou.mp3?v=1588140133"
      );
      $(this).find(".soundwave-active").addClass("playing");
      setTimeout(function () {
        $("#hintButton04").find(".soundwave-active").removeClass("playing");
      }, 400);
    });
    $("#hintButton05").click(function () {
      showSound(
        "https://cdn.shopify.cn/s/files/1/0012/4957/4961/files/putonghongzhou.mp3?v=1588140136"
      );
      $(this).find(".soundwave-active").addClass("playing");
      setTimeout(function () {
        $("#hintButton05").find(".soundwave-active").removeClass("playing");
      }, 400);
    });
  })();

  $('.btn-graphic-ctn').click(function() {
    $(this).find('.soundwave-active').addClass('playing')
    $(this).siblings('audio')[0].play()
  })


  // 产品详情图片添加 width 和 height
  $('.product-tab-content-container #product-tab-content1 img').each(function() {
    var width = $(this).attr('width')

    if (width == undefined) {
      $(this).attr('width', '100')
    }

    var height = $(this).attr('height')

    if (height == undefined) {
      $(this).attr('height', '100')
    }

  })

  // TDF Bundle 表单标签由 base-ada.js 的 fixTdfBundleFormLabels 处理
  //（勿再写入泛化 aria-label，会覆盖带产品名的可访问名称）
});
